import useUiData from './useUiData';
import useGrades from '../../dataSource/ui/useGrades';

const useGradesIdMapping = () => {
	const { isPending: uiPending, isError: uiError, data: { grades } } = useUiData(['grades']);
	const { isPending: gradesPending, isError: gradesError, data: gradesData } = useGrades();

	const isPending = uiPending || gradesPending;
	const isError = uiError || gradesError;

	const mapping = {};
	if(!isPending && !isError){
		grades.forEach(({ id, name }) => {
			mapping[id] = gradesData.find(g => g.name === name).id;
		});
	}

	return { isPending, isError, mapping }
};

export default useGradesIdMapping;
